import React from 'react';
import './aboutPage.css';


const AboutPage = () => {
  
  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12">


          <h4>Page About</h4>


          
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
